import { AddIcon } from '@chakra-ui/icons';
import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import PlatformAccordion from 'pages/telephony/numbers/edit/accordionComponents/PlatformAccordion';
import { MdCallSplit } from 'react-icons/md';
import { useSelector } from 'react-redux';

const GroupDropZone = ({
    pendingPlatforms = [],
    isDraggingOver,
    previousData = [],
    // Props needed for PlatformAccordion
    submitData = [],
    setSubmitData,
    teamsTrunks = [],
    callingProfiles = [],
    OC,
    selectedTrunk,
    setSelectedTrunk,
    trsRegistrations = [],
    onRemoveFromPending,
    errors = {},
    touched = {},
    values = [],
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    const platformCount = pendingPlatforms.length;

    const getContent = () => {
        if (platformCount === 0) {
            return {
                icon: AddIcon,
                text: 'Creating Branch Routing Group - Drop platforms here',
                showIcon: false,
            };
        } else if (platformCount === 1) {
            return {
                icon: MdCallSplit,
                text: 'Drop one more platform to create group',
                showIcon: false,
            };
        } else {
            return {
                icon: MdCallSplit,
                text: `Branch Routing Group (${platformCount} platforms)`,
                showIcon: true,
                showPriority: true,
            };
        }
    };

    const content = getContent();

    return (
        <Box mt={4}>
            <Box
                border="2px dashed"
                borderColor={
                    isDraggingOver
                        ? 'blue.400'
                        : platformCount >= 2
                          ? 'green.400'
                          : platformCount === 1
                            ? 'blue.400'
                            : 'gray.400'
                }
                borderRadius="md"
                bg={
                    isDraggingOver
                        ? darkMode
                            ? 'blue.900'
                            : 'blue.50'
                        : platformCount >= 1
                          ? darkMode
                              ? 'gray.800'
                              : 'gray.50'
                          : 'transparent'
                }
                _hover={{
                    borderColor: platformCount >= 2 ? 'green.500' : 'blue.400',
                    bg: darkMode ? 'blue.900' : 'blue.50',
                }}
                transition="all 0.2s"
                minH="80px"
                p={4}
                cursor={platformCount >= 2 ? 'default' : 'pointer'}>
                <HStack
                    spacing={3}
                    mb={platformCount > 0 ? 3 : 0}
                    justify="center">
                    {content.showIcon && (
                        <Icon
                            as={content.icon}
                            boxSize={platformCount >= 2 ? 6 : 5}
                            color={
                                platformCount >= 2
                                    ? 'green.500'
                                    : platformCount === 1
                                      ? 'blue.500'
                                      : darkMode
                                        ? 'gray.300'
                                        : 'gray.600'
                            }
                        />
                    )}
                    <Text
                        fontSize={platformCount >= 1 ? 'md' : 'lg'}
                        fontWeight={platformCount >= 1 ? 'semibold' : 'medium'}
                        color={
                            platformCount >= 2
                                ? 'green.500'
                                : platformCount === 1
                                  ? 'blue.500'
                                  : darkMode
                                    ? 'gray.300'
                                    : 'gray.600'
                        }>
                        {platformCount >= 1
                            ? `Creating Branch Routing Group (${platformCount} platform${platformCount > 1 ? 's' : ''}) - Drop one more`
                            : content.text}
                    </Text>
                </HStack>

                {platformCount > 0 && (
                    <VStack spacing={2} align="stretch" w="100%">
                        {pendingPlatforms.map((platform, index) => {
                            return (
                                <Box
                                    key={platform.platformID}
                                    position="relative"
                                    p={3}
                                    bg={
                                        darkMode ? 'whiteAlpha.100' : 'gray.100'
                                    }
                                    borderRadius="md"
                                    border="2px solid"
                                    borderColor="blue.300">
                                    <PlatformAccordion
                                        platformId={platform.platformID}
                                        platform={platform}
                                        errors={errors}
                                        touched={touched}
                                        value={values}
                                        submitData={submitData}
                                        setSubmitData={setSubmitData}
                                        teamsTrunks={teamsTrunks}
                                        callingProfiles={callingProfiles}
                                        OC={OC}
                                        platformIndex={index}
                                        platformNumbersLength={platformCount}
                                        selectedTrunk={selectedTrunk}
                                        setSelectedTrunk={setSelectedTrunk}
                                        previousData={previousData}
                                        trsRegistrations={trsRegistrations}
                                        onRemovePlatform={onRemoveFromPending}
                                    />
                                </Box>
                            );
                        })}
                    </VStack>
                )}
            </Box>

            {platformCount === 0 && (
                <Text fontSize="sm" color="gray.500" mt={2} textAlign="center">
                    Drag platforms here to create a group that rings
                    simultaneously
                </Text>
            )}
        </Box>
    );
};

export default GroupDropZone;
